import {
    convertMetersToFeet,
    roundToFourSigFigs,
} from '@Utils/helpers/numericalHelpers';
import _camelCase from 'lodash/camelCase';
import _isEmpty from 'lodash/isEmpty';
import _isNaN from 'lodash/isNaN';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import _startCase from 'lodash/startCase';
import React from 'react';
import Symbology from '@Views/QualityControl/styles/symbology.scss';
import EntityDrawerAttributeRow from './EntityDrawerAttributeRow';
import { NestLevel } from './EntityDrawerAttributeRow';
import NestedAccordion from './NestedAccordion/NestedAccordion';

export const isFalsy = (value: any) => {
    if (value === false) return false;
    if (value === 'Select an option') return true;
    if (_isNil(value)) return true;
    if (Array.isArray(value)) {
        return value.length === 0;
    } else if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }
    return !value;
};

export const renderIkeOfficeData = (data, originalDataSet?) => {
    const searchData = originalDataSet ? originalDataSet : data;
    const displayData = Array.isArray(data)
        ? data
        : data.generic_data[0].fields;
    const componentisedData = displayData.map((item, index) => {
        const lowerCaseItemType = item.type.toLowerCase();
        if (isFalsy(item.value)) {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value}
                />
            );
        } else if (lowerCaseItemType === 'nestedlist') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value.map((subitem, index) => {
                        if (index !== item.value.length - 1)
                            return subitem.value + ' > ';
                        else return subitem.value;
                    })}
                />
            );
        } else if (lowerCaseItemType === 'text') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value}
                />
            );
        } else if (lowerCaseItemType === 'selectlist') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value.title}
                />
            );
        } else if (lowerCaseItemType === 'image') {
            return (
                <NestedAccordion
                    key={index}
                    title={item.name + ' (' + item.value.length + ')'}
                    defaultClosed={true}
                    data={item.value.map((imageId, index) => {
                        const captureData =
                            searchData.generic_data[0].captures.find(
                                (capture) => capture.id === imageId
                            );
                        if (captureData.type === 'image') {
                            return (
                                <EntityDrawerAttributeRow
                                    key={captureData.id}
                                    nestLevel={NestLevel.IMAGE}
                                    value={<img src={captureData.imageUrl} />}
                                />
                            );
                        }
                    })}
                />
            );
        } else if (lowerCaseItemType === 'truesizecapture') {
            return (
                <NestedAccordion
                    key={index}
                    title={item.name + ' (' + item.value.length + ')'}
                    defaultClosed={true}
                    data={item.value.map((imageId, index) => {
                        const captureData =
                            searchData.generic_data[0].captures.find(
                                (capture) => capture.id === imageId
                            );
                        const compositeUrl = !_isNil(captureData.compositeUrl)
                            ? captureData.compositeUrl
                            : '';
                        return (
                            <EntityDrawerAttributeRow
                                key={captureData.id}
                                nestLevel={NestLevel.IMAGE}
                                value={
                                    <img
                                        src={compositeUrl}
                                        style={{ height: '180px' }}
                                    />
                                }
                            />
                        );
                    })}
                />
            );
        } else if (lowerCaseItemType === 'height') {
            let imageAccordion = null;
            if (
                item.provider.type === 'spanheight' &&
                !isFalsy(item.provider.points)
            ) {
                imageAccordion = (
                    <NestedAccordion
                        key={'spanImages'}
                        title={'Midspan Height Images'}
                        defaultClosed={true}
                        data={item.provider.points.map((imageId, index) => {
                            const captureData =
                                searchData.generic_data[0].captures.find(
                                    (capture) => capture.id === imageId
                                );
                            const imageUrl = !_isNil(captureData.thumbnailUrl)
                                ? captureData.thumbnailUrl
                                : '';
                            return (
                                <EntityDrawerAttributeRow
                                    key={captureData.id}
                                    nestLevel={NestLevel.IMAGE}
                                    value={
                                        <img
                                            src={imageUrl}
                                            style={{ height: '180px' }}
                                        />
                                    }
                                />
                            );
                        })}
                    />
                );
            }

            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={roundToFourSigFigs(item.value)}
                    subElement={imageAccordion}
                />
            );
        } else if (lowerCaseItemType === 'location') {
            const providerType = item.provider.type;
            const providerTitle = `Provider \u2014 ${
                providerType === 'gps' ? 'GPS' : 'Manually edited'
            } location`;
            const getProviderLineTitle = (key) => {
                return _startCase(_camelCase(key));
            };
            const providerAccordion = (
                <NestedAccordion
                    key={'provider'}
                    title={providerTitle}
                    data={Object.keys(item.provider).map((key, index) => {
                        return (
                            <EntityDrawerAttributeRow
                                key={key}
                                keyName={getProviderLineTitle(key)}
                                value={
                                    key === 'accuracy'
                                        ? convertMetersToFeet(item.value[key])
                                        : roundToFourSigFigs(item.value[key])
                                }
                            />
                        );
                    })}
                />
            );
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={Object.keys(item.value).map((key, index) => {
                        return (
                            <EntityDrawerAttributeRow
                                key={key}
                                keyName={key}
                                value={
                                    key === 'accuracy'
                                        ? convertMetersToFeet(item.value[key])
                                        : roundToFourSigFigs(item.value[key])
                                }
                                nestLevel={NestLevel.VALUE}
                            />
                        );
                    })}
                    subElement={providerAccordion}
                />
            );
        } else if (lowerCaseItemType === 'vector') {
            let imageAccordion = null;
            if (
                item.provider.type === 'pointtopoint' &&
                !isFalsy(item.provider.points)
            ) {
                imageAccordion = (
                    <NestedAccordion
                        key={'spanImages'}
                        title={'Span Images'}
                        defaultClosed={true}
                        data={item.provider.points.map((imageId, index) => {
                            const captureData =
                                searchData.generic_data[0].captures.find(
                                    (capture) => capture.id === imageId
                                );
                            const imageUrl = !_isNil(captureData.thumbnailUrl)
                                ? captureData.thumbnailUrl
                                : '';
                            return (
                                <EntityDrawerAttributeRow
                                    key={captureData.id}
                                    nestLevel={NestLevel.IMAGE}
                                    value={
                                        <img
                                            src={imageUrl}
                                            style={{ height: '180px' }}
                                        />
                                    }
                                />
                            );
                        })}
                    />
                );
            }

            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={Object.keys(item.value).map((key, index) => {
                        return (
                            <EntityDrawerAttributeRow
                                key={key}
                                keyName={key}
                                value={roundToFourSigFigs(item.value[key])}
                                nestLevel={NestLevel.VALUE}
                            />
                        );
                    })}
                    subElement={imageAccordion}
                />
            );
        } else if (lowerCaseItemType === 'yesno') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value ? 'Yes' : 'No'}
                />
            );
        } else if (lowerCaseItemType === 'number') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value}
                />
            );
        } else if (lowerCaseItemType === 'form') {
            const getNestedTitle = (innerItem) => {
                if (
                    item.name === 'Equipment' &&
                    !isFalsy(
                        innerItem.fields.find((field) => field.name === 'Type')
                            .value
                    )
                ) {
                    const equipmentTitleElement = innerItem.fields.find(
                        (field) => field.name === 'Type'
                    );
                    const equipmentTitle = `${item.name} #${index + 1} \u2014 ${
                        equipmentTitleElement.value[0].value
                    } > ${equipmentTitleElement.value[1].value}`;
                    return equipmentTitle;
                } else if (
                    item.name === 'Guys' &&
                    !isFalsy(
                        innerItem.fields.find((field) => field.name === 'Size')
                            .value
                    )
                ) {
                    const guysTitleElement = innerItem.fields.find(
                        (field) => field.name === 'Size'
                    );
                    const guysTitle = `${item.name} #${index + 1} \u2014 ${
                        guysTitleElement.value[0].value
                    } > ${guysTitleElement.value[1].value}`;
                    return guysTitle;
                } else if (
                    item.name === 'Wire' &&
                    !isFalsy(
                        innerItem.fields.find((field) => field.name === 'Size')
                            .value
                    )
                ) {
                    const wireTitleElement = innerItem.fields.find(
                        (field) => field.name === 'Size'
                    );
                    const wireTitle = `${item.name} #${index + 1} \u2014 ${
                        wireTitleElement.value[0].value
                    } > ${wireTitleElement.value[1].value}`;
                    return wireTitle;
                } else if (
                    item.name === 'Anchor' &&
                    !isFalsy(
                        innerItem.fields.find((field) => field.name === 'Owner')
                            .value
                    )
                ) {
                    const anchorTitleElement = innerItem.fields.find(
                        (field) => field.name === 'Owner'
                    );
                    const anchorTitle = `${item.name} #${index + 1} \u2014 ${
                        anchorTitleElement.value[0].value
                    } > ${anchorTitleElement.value[1].value}`;
                    return anchorTitle;
                } else if (
                    item.name === 'Span' &&
                    !isFalsy(
                        innerItem.fields.find((field) => field.name === 'Type')
                            .value
                    )
                ) {
                    const spanTitleElement = innerItem.fields.find(
                        (field) => field.name === 'Type'
                    );
                    const spanTitle = `${item.name} #${index + 1} \u2014 ${
                        spanTitleElement.value.title
                    }`;
                    return spanTitle;
                } else if (
                    item.name === 'Make Ready' &&
                    !isFalsy(
                        innerItem.fields.find((field) =>
                            field.name.includes('Size')
                        )
                    )
                ) {
                    const makeReadyTitleElement = innerItem.fields.find(
                        (field) => field.name.includes('Size')
                    );
                    const makeReadyTitle = `${item.name} #${index + 1} \u2014 ${
                        makeReadyTitleElement.value
                    }`;
                    return makeReadyTitle;
                } else {
                    return `${item.name} #${index + 1}`;
                }
            };

            return (
                <NestedAccordion
                    key={index}
                    title={item.name + ' (' + item.value.length + ')'}
                    data={item.value.map((innerItem, index) => {
                        const innerItemTitle = getNestedTitle(innerItem);

                        return (
                            <NestedAccordion
                                key={index}
                                title={innerItemTitle}
                                data={renderIkeOfficeData(
                                    innerItem.fields,
                                    searchData
                                )}
                            />
                        );
                    })}
                />
            );
        } else {
            return null;
        }
    });
    const filteredData = componentisedData.filter((item) => item !== null);
    return filteredData;
};

export const renderPoleBasics = (data, originalDataSet?, columnWidth?) => {
    const searchData = originalDataSet ? originalDataSet : data;

    const displayData = Array.isArray(data)
        ? data
        : data.generic_data[0].fields;
    const componentisedData = displayData.map((item, index) => {
        const lowerCaseItemType = item.type.toLowerCase();
        if (isFalsy(item.value)) {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'nestedlist') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value.map((subitem, index) => {
                        if (index !== item.value.length - 1)
                            return subitem.value + ' > ';
                        else return subitem.value;
                    })}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'text') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'selectlist') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value.title}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'image') {
            return null;
        } else if (lowerCaseItemType === 'truesizecapture') {
            return null;
        } else if (lowerCaseItemType === 'height') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={convertMetersToFeet(item.value)}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'location') {
            const items = Object.keys(item.value).map((key, index) => {
                if (key === 'accuracy') {
                    return (
                        <EntityDrawerAttributeRow
                            key={key}
                            keyName={key}
                            value={convertMetersToFeet(item.value[key])}
                            nestLevel={NestLevel.VALUE}
                        />
                    );
                } else {
                    return (
                        <EntityDrawerAttributeRow
                            key={key}
                            keyName={key}
                            value={roundToFourSigFigs(item.value[key])}
                            nestLevel={NestLevel.VALUE}
                        />
                    );
                }
            });

            let providerRow = null;

            if (!_isNil(item.provider)) {
                const accuracyClass = data['accuracy_class'] ?? null;
                const getValue = (k, v) => {
                    if (k === 'antennaHeight') {
                        return convertMetersToFeet(v);
                    } else if (k === 'undulation') {
                        return roundToFourSigFigs(v);
                    }
                    return v;
                };
                const providerItems = Object.entries(item.provider)
                    .filter(([key]) => key !== 'capturedAt')
                    .map(([key, value]) => {
                        return (
                            <EntityDrawerAttributeRow
                                key={key}
                                keyName={key}
                                value={getValue(key, value)}
                                nestLevel={NestLevel.VALUE}
                            />
                        );
                    });

                providerRow = (
                    <EntityDrawerAttributeRow
                        key={`${index}provider`}
                        keyName={'Provider'}
                        value={providerItems}
                        columnWidth={columnWidth}
                        valueStyles={getAccuracyStyling(accuracyClass)}
                    />
                );
            }

            return (
                <>
                    <EntityDrawerAttributeRow
                        key={index}
                        keyName={item.name}
                        value={items}
                        columnWidth={columnWidth}
                    />
                    {providerRow}
                </>
            );
        } else if (lowerCaseItemType === 'vector') {
            let imageAccordion = null;
            if (
                item.provider.type === 'pointtopoint' &&
                !isFalsy(item.provider.points)
            ) {
                imageAccordion = (
                    <NestedAccordion
                        key={'spanImages'}
                        title={'Span Images'}
                        defaultClosed={true}
                        data={item.provider.points.map((imageId, index) => {
                            const captureData =
                                searchData.generic_data[0].captures.find(
                                    (capture) => capture.id === imageId
                                );
                            const imageUrl = !_isNil(captureData.thumbnailUrl)
                                ? captureData.thumbnailUrl
                                : '';
                            return (
                                <EntityDrawerAttributeRow
                                    key={captureData.id}
                                    nestLevel={NestLevel.IMAGE}
                                    value={
                                        <img
                                            src={imageUrl}
                                            style={{ height: '180px' }}
                                        />
                                    }
                                    columnWidth={columnWidth}
                                />
                            );
                        })}
                    />
                );
            }

            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={Object.keys(item.value).map((key, index) => {
                        return (
                            <EntityDrawerAttributeRow
                                key={key}
                                keyName={key}
                                value={roundToFourSigFigs(item.value[key])}
                                nestLevel={NestLevel.VALUE}
                            />
                        );
                    })}
                    subElement={imageAccordion}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'yesno') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value ? 'Yes' : 'No'}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'number') {
            return (
                <EntityDrawerAttributeRow
                    key={index}
                    keyName={item.name}
                    value={item.value}
                    columnWidth={columnWidth}
                />
            );
        } else if (lowerCaseItemType === 'form') {
            return null;
        }
    });
    const filteredData = componentisedData.filter((item) => item !== null);
    return filteredData;
};

export const renderEquimentAndWireInfo = (data, type) => {
    const getTitle = (data): string => {
        if (type === 'equipment') {
            return data.equipment_name;
        } else if (type === 'wire') {
            return data.wire_size;
        }
    };

    const title = getTitle(data[0]);

    const fields = renderFields(data);

    return { title: title, dataList: fields };
};

const renderFields = (data: { name: string; value: any }[]) => {
    return data.map((d) => (
        <EntityDrawerAttributeRow
            key={d.name}
            keyName={d.name}
            value={d.value}
        />
    ));
};

export const getAccuracyStyling = (accuracy: {
    accuracy_class_id: number;
    accuracy_label: string;
}): React.CSSProperties => {
    if (_isNil(accuracy) || _isNil(accuracy?.accuracy_label)) {
        return null;
    }

    const accuracyLabel = accuracy.accuracy_label.toLowerCase();

    if (
        accuracyLabel.indexOf('reviewed') > -1 ||
        accuracyLabel.indexOf('fixed') > -1
    ) {
        return {
            color: '#000',
            backgroundColor: Symbology.accuracyFixed,
        };
    } else if (accuracyLabel.indexOf('float') > -1) {
        return {
            color: '#000',
            backgroundColor: Symbology.accuracyFloat,
        };
    } else if (accuracyLabel.indexOf('low') > -1) {
        return {
            color: '#fff',
            backgroundColor: Symbology.accuracyLow,
        };
    } else {
        console.log(`found new accuracy label: ${accuracyLabel}`);
        return {
            color: '#fff',
            backgroundColor: '#000',
        };
    }
};
